'use client';

import React from 'react';

import { DEV_LÄGE_AKTIVT } from 'src/lib/dev-lage';

import { AuthProvider } from './firebase';
import { DevAuthProvider } from './dev';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

/**
 * Väljer inloggningsprovider.
 *
 * `DEV_LÄGE_AKTIVT` kräver både `NEXT_PUBLIC_AUTH_MODE=dev` och ett
 * icke-produktionsbygge, så ett produktionsbygge kan inte hamna i dev-läget ens
 * om flaggan råkar följa med i miljön.
 *
 * Valet görs vid modulnivå och inte i en effekt — providern får inte hinna
 * växla efter första renderingen, för då skulle Firebase-providern kort ha satt
 * `unauthenticated` och `AuthGuard` redan ha omdirigerat till inloggningen.
 */
export function AuthProviderVäljare({ children }: Props) {
  if (DEV_LÄGE_AKTIVT) {
    return <DevAuthProvider>{children}</DevAuthProvider>;
  }

  return <AuthProvider>{children}</AuthProvider>;
}
